import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import error from '../../assets/404.svg';

const NotFound = () => {
    return(
        <main>
        <Container fluid>
            <div>
                <Row className="justify-content-md-center">
                    <Col sm={12} md={12} lg={12} className="d-none d-lg-block" style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <br></br>
                        <h3>Página não encontrada!</h3>
                        <br></br>
                        <img src={error} alt="Not Found" style={{width: '365px'}} />
                    </Col>
                </Row>
            </div>
        </Container>
        </main>
    );
}

export default NotFound;